import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faPiggyBank, faCheckSquare, faSquare, faTag, faBolt, faCalendarCheck } from '@fortawesome/free-solid-svg-icons';
import styles from '../../styles/common/ExternalServiceCard.module.css';

export interface ExternalServiceData {
    serviceName: string;
    serviceQty: number;
    servicePrice: number;
    serviceSubTotal: number;
    idExternalCourierService: number;
    transitDays: string | null;
    estimatedDeliveryDate?: string | null;
    standardPrice?: number | null;
    discountPercent?: number | null;
}

interface ExternalServiceCardProps {
    service: ExternalServiceData;
    isSelected?: boolean;
    onClick?: () => void;
    currency?: string;
    badgeType?: 'lowest' | 'recommended' | 'express' | null;
}

export const ExternalServiceCard: React.FC<ExternalServiceCardProps> = ({
    service,
    isSelected = false,
    onClick,
    currency = 'USD',
    badgeType = null
}) => {
    return (
        <div 
            className={`${styles.cardContainer} ${isSelected ? styles.selected : ''}`}
            onClick={onClick}
        >
            <div className={styles.topRow}>
                <div className={styles.checkWrapper}>
                    {isSelected ? (
                        <FontAwesomeIcon icon={faCheckSquare} className={styles.checkIconActive} />
                    ) : (
                        <FontAwesomeIcon icon={faSquare} className={styles.checkIconInactive} />
                    )}
                </div>

                {badgeType === 'lowest' && (
                    <div className={`${styles.badge} ${styles.lowestBadge}`}>
                        <FontAwesomeIcon icon={faPiggyBank} className={styles.badgeIcon} />
                        MENOR COSTO
                    </div>
                )}
                {badgeType === 'recommended' && (
                    <div className={`${styles.badge} ${styles.recommendedBadge}`}>
                        <FontAwesomeIcon icon={faCheckCircle} className={styles.badgeIcon} />
                        RECOMENDADO
                    </div>
                )}
                {badgeType === 'express' && (
                    <div className={`${styles.badge} ${styles.expressBadge}`}>
                        <FontAwesomeIcon icon={faBolt} className={styles.badgeIcon} />
                        MÁS RÁPIDO
                    </div>
                )}
                {service.discountPercent && service.discountPercent > 0 && (
                    <div className={`${styles.badge} ${styles.discountBadge}`}>
                        <FontAwesomeIcon icon={faTag} className={styles.badgeIcon} />
                        {service.discountPercent.toFixed(1)}% DESCUENTO
                    </div>
                )}
            </div>
            
            <div className={styles.body}>
                <h4 className={styles.serviceName}>{service.serviceName}</h4>
                <div className={styles.priceRow}>
                    <span className={styles.priceValue}>
                        ${service.serviceSubTotal.toFixed(2)}
                    </span>
                    <span className={styles.currency}>{currency}</span>
                </div>
                {service.standardPrice && service.discountPercent && service.discountPercent > 0 && (
                    <div className={styles.standardPriceRow}>
                        <span className={styles.standardPriceLabel}>Tarifa regular:</span>
                        <span className={styles.strikethroughPrice}>
                            ${service.standardPrice.toFixed(2)} {currency}
                        </span>
                    </div>
                )}
                {service.transitDays && service.transitDays !== "N/A" && (
                    <div className={styles.transitContainer}>
                        <div className={styles.transitDays}>
                            <span className={styles.transitLabel}>Días en Tránsito:</span> {service.transitDays} {parseInt(service.transitDays) === 1 ? 'día' : 'días'}
                        </div>
                        {service.estimatedDeliveryDate && (
                            <div className={styles.deliveryDateRow}>
                                <FontAwesomeIcon icon={faCalendarCheck} className={styles.calendarIcon} />
                                <span className={styles.deliveryDateText}>Entrega: {service.estimatedDeliveryDate}</span>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ExternalServiceCard;
